import request from "@/util/http";
import qs from "qs"; // 获取方案列表

export function getPlanDesktopVoList(query) {
  return request({
    url: "/admin/tHallOaDefineDesktop/getPlanDesktopVoList",
    method: "get",
    params: query
  });
} // 获取信息导航

export function getNavigationList(query) {
  return request({
    url: "/admin/homeTemplate/getNavigationList",
    method: "get",
    params: query
  });
} // 获取专题分类

export function getTopicCatalogList(query) {
  return request({
    url: "/admin/homeTemplate/getTopicCatalogList",
    method: "get",
    params: query
  });
} // 获取主题分类

export function getSubjectCatalogList(query) {
  return request({
    url: "/admin/homeTemplate/getSubjectCatalogList",
    method: "get",
    params: query
  });
} // 创建方案

export function createPlanDesktop(data) {
  return request({
    url: "/admin/tHallOaDefineDesktop/createPlanDesktop",
    method: "post",
    data: data
  });
} // 删除方案

export function deletePlanDesktop(id) {
  return request({
    url: "/admin/tHallOaDefineDesktop/deletePlanDesktop",
    method: "get",
    params: id
  });
} // 编辑方案

export function editPlanDesktop(data) {
  return request({
    url: "/admin/tHallOaDefineDesktop/editPlanDesktop",
    method: "post",
    data: data
  });
} // 保存桌面

export function savePageDeskVo(data) {
  return request({
    url: "/admin/homeTemplate/savePageDeskVo",
    method: "post",
    data: data
  });
} // 获取服务评价

export function getServeCommentList(query) {
  return request({
    url: "/admin/homeTemplate/getServeCommentList",
    method: "get",
    params: query
  });
} //获取校历周

export function getCalendar(query) {
  return request({
    url: "/admin/homeTemplate/getCalendar",
    method: "get",
    params: query
  });
} //获取便签

export function getNodeList(query) {
  return request({
    url: "/admin/homeTemplate/getLableList",
    method: "get",
    params: query
  });
} //新增或修改便签

export function setNode(data) {
  return request({
    url: "/admin/homeTemplate/saveLable",
    method: "post",
    data: data
  });
} //删除便签

export function delNode(id) {
  return request({
    url: "/admin/homeTemplate/deleteLable?id=" + id,
    method: "post"
  });
} //获取日程

export function getSchList(query) {
  return request({
    url: "/admin/homeTemplate/getScheduleList",
    method: "get",
    params: query
  });
} //删除日程

export function delSch(id) {
  return request({
    url: "/admin/homeTemplate/deleteSchedule?id=" + id,
    method: "post"
  });
} //新增日程

export function addSch(data) {
  return request({
    url: "/admin/homeTemplate/saveSchedule",
    method: "post",
    data: data
  });
}